import React from 'react'
import {Link} from 'react-router-dom';
import Logo from './Logo';
import phone from "../images/icons/phone.png"
function RegularNavigation() {
  return (
    <header id= "regular-nav">
      <ul className= "navbar">
        <li>
            <Link to="/">Home</Link>
        </li>
        <li>
            <Link to="/Services">Services</Link>
        </li>
        <li>
            <Link to="/Estimate">Estimate</Link>
        </li>
      </ul>
      <Logo/>
        <div>
          <div id= "header-contact">
            
            <a href="tel:781-228-8783">
            <img id= "phone-icon" src={phone} alt="" />
              <p id= "phone-number">781-228-8783</p>
              </a>
          </div>
        
        </div>
    </header>
    
  )
}

export default RegularNavigation;